import { render } from "./SidebarWrapper.vue?vue&type=template&id=3ed97a94&scoped=true&ts=true"
import script from "./SidebarWrapper.vue?vue&type=script&lang=ts"
export * from "./SidebarWrapper.vue?vue&type=script&lang=ts"

import "./SidebarWrapper.vue?vue&type=style&index=0&id=3ed97a94&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed97a94"]])

export default __exports__